export const convertFromDbDateToSimpleDate = (dbDate) => {
  if (!dbDate) return null;
  const dateObj = new Date(dbDate?.replace(" ", "T") + "Z");
  return dateObj?.toISOString().split("T")[0];
};
